module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_1536.6bd32b94.jpg";